<template>
    <div>
        <v-alert type="info" text class="mb-5">
            Sélectionnez les champs à renseigner par vos pros pour la validation du formulaire.
        </v-alert>
        <v-data-table
          :headers="headers"
          :items="administrativeDatas"
          :hide-default-footer="true"
          :items-per-page="20"
        >
            <template v-slot:item.label="{ item }">
                <div>{{ item.label }}</div>
            </template>

            <template v-slot:item.check="{ item }">
                <div><v-checkbox class="mt-0 mr-5"
                                 style="padding-top: 0 !important;"
                                 v-model="item.check"
                                 @change="removeRequired(item)"
                                 hide-details>
                </v-checkbox></div>
            </template>

            <template v-slot:item.required="{ item }">
                <div><v-checkbox class="mt-0 mr-5"
                                 style="padding-top: 0 !important;"
                                 v-model="item.required"
                                 @change="autoCheck(item)"
                                 hide-details>
                </v-checkbox></div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "AdministrativeDatas",
    data() {
        return {
            headers: [
                {
                    text: 'Information',
                    align:'start',
                    sortable: false,
                    value:'label'
                },
                {
                    text: 'Demandé',
                    align:'start',
                    sortable: false,
                    value:'check'
                },
                {
                    text: 'Obligatoire',
                    align:'start',
                    sortable: false,
                    value:'required'
                },
            ],
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setParameterCurrentStep"]),
        autoCheck(item) {
            if(item.check === false) {
                item.check = true
            }

            this.updateField(item)
        },
        removeRequired(item) {
            if(item.check === false) {
                item.required = false
            }

            this.updateField(item)
        },
        updateField(item) {
            let payload= {
                'configId': this.cadhConfig.id,
                'check': item.check,
                'code': item.code,
                'required': item.required,
            }

            this.$global.loading = true

            this.$store.dispatch("cadhConfig/updateConfigurationField", payload)

            this.$global.loading = false
        }
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "parameterCurrentStep", "administrativeDatas"]),
    },
}
</script>